<template>
  <div class="kefu_box">
  </div>
</template>

<script>
export default {
  data() {
    return {
      qiyuUrl: '',
      sdkTimer: null,
      sdkHandled: false,
    }
  },
  mounted() {
    const self = this
    ;(function (w, d, n, a, j) {
      w[n] =
        w[n] ||
        function () {
          ;(w[n].a = w[n].a || []).push(arguments)
        }
      j = d.createElement('script')
      j.async = false
      j.src =
        'https://qiyukf.com/script/fa9fdc3c4baf6db3cdfa77121d1cc324.js?hidden=1'
      // 脚本加载失败（断网 / 被拦截 / CDN 不可达）时立即提示，无需等到超时
      j.onerror = function () {
        self.onSdkError()
      }
      d.body.appendChild(j)
    })(window, document, 'ysf')
    // ysf 是异步加载器：未就绪前的调用会先入队，SDK 加载完成后自动补执行，
    // 因此这里无需再用固定延时“猜”加载时机，直接调用即可
    this.qiyu()
  },
  beforeDestroy() {
    // 组件已销毁：置位闸门，让残留的 onready / onerror 回调直接短路，
    // 否则用户离开客服页后 SDK 才就绪，仍会被强行跳转或弹出提示
    this.sdkHandled = true
    if (this.sdkTimer) {
      clearTimeout(this.sdkTimer)
      this.sdkTimer = null
    }
  },
  created() {},
  methods: {
    qiyu() {
      //   const queryObject = this.$route.query
      //   console.log(queryObject)
      //   console.log(queryObject)

      //   console.log(window.location.href)
      //   console.log('a', JSON.parse(this.$route.query.json))
      //   console.log(this.$route.query)
      //   let strs = Object.keys(this.$route.query)[0].split('&')
      //   var object = {}
      //   for (var i = 0; i < strs.length; i++) {
      //     object[strs[i].split('=')[0]] = strs[i].split('=')[1] //得到{id:'123456',name:'www'}
      //   }
      //   console.log(object)

      //   console.log(this.GetRequest('channel'))
      //   console.log(
      //     decodeURI(
      //       'username%3D%26open_id%3D%26channel%3D3001%26server%3D1%26uid%3D4884981%26role_name%3D肚饿资质%26phone%3D%26app_name%3D猫之城'
      //     )
      //   )
      //   this.GetRequest()
      //   const url =
      //     'https://user-center.duobaogame.com/#/gameKefu?phone=""&app_name=""&username=""&role_name=""&uid=""&channel=""&server=""&open_id=""'
      //   ?phone="11"&app_name="22"&username="33"&role_name="44"&uid="55"&channel="66"&server="77"&open_id="88"
      //   const data = [
      //     {
      //       key: 'mobile_phone',
      //       value: this.$route.query.phone
      //         ? decodeURI(this.$route.query.phone)
      //         : '',
      //     },
      //     {
      //       key: 'app_name',
      //       label: '游戏项目',
      //       value: this.$route.query.app_name
      //         ? decodeURI(this.$route.query.app_name)
      //         : '',
      //     },
      //     {
      //       key: 'username',
      //       label: '通行证账号',
      //       value: this.$route.query.username
      //         ? decodeURI(this.$route.query.username)
      //         : '',
      //     },
      //     {
      //       key: 'role_name',
      //       label: '角色名',
      //       value: this.$route.query.role_name
      //         ? decodeURI(this.$route.query.role_name)
      //         : '',
      //     },
      //     {
      //       key: 'uid',
      //       label: '玩家UID',
      //       value: this.$route.query.uid ? decodeURI(this.$route.query.uid) : '',
      //     },
      //     {
      //       key: 'channel',
      //       label: '渠道',
      //       value: this.$route.query.channel
      //         ? decodeURI(this.$route.query.channel)
      //         : '',
      //     },
      //     {
      //       key: 'server',
      //       label: '区服',
      //       value: this.$route.query.server
      //         ? decodeURI(this.$route.query.server)
      //         : '',
      //     },
      //   ]
      //   console.log(data)
      ysf('config', {
        uid: this.$route.query.open_id,
        data: JSON.stringify([
          {
            key: 'mobile_phone',
            value: this.$route.query.phone
              ? decodeURI(this.$route.query.phone)
              : '',
          },
          {
            key: 'app_name',
            label: '游戏项目',
            value: this.$route.query.app_name
              ? decodeURI(this.$route.query.app_name)
              : '',
          },
          {
            key: 'username',
            label: '通行证账号',
            value: this.$route.query.username
              ? decodeURI(this.$route.query.username)
              : '',
          },
          {
            key: 'role_name',
            label: '角色名',
            value: this.$route.query.role_name
              ? decodeURI(this.$route.query.role_name)
              : '',
          },
          {
            key: 'uid',
            label: '玩家UID',
            value: this.$route.query.uid
              ? decodeURI(this.$route.query.uid)
              : '',
          },
          {
            key: 'channel',
            label: '渠道',
            value: this.$route.query.channel
              ? decodeURI(this.$route.query.channel)
              : '',
          },
          {
            key: 'server',
            label: '区服',
            value: this.$route.query.server
              ? decodeURI(this.$route.query.server)
              : '',
          },
        ]),
      })

      const self = this
      // 真正等待 SDK 就绪回调触发后再跳转客服地址，避免同步读取标志位造成误判
      ysf('onready', function () {
        self.onSdkReady()
      })
      // 超时兜底：网络过慢或脚本长时间未就绪时给出提示
      this.sdkTimer = setTimeout(function () {
        self.onSdkError()
      }, 10000)
    },
    onSdkReady() {
      if (this.sdkHandled) return
      this.sdkHandled = true
      if (this.sdkTimer) clearTimeout(this.sdkTimer)
      location.href = ysf('url')
      // this.qiyuUrl = ysf('url')
    },
    onSdkError() {
      if (this.sdkHandled) return
      this.sdkHandled = true
      if (this.sdkTimer) clearTimeout(this.sdkTimer)
      alert('sdk尚未加载成功，请稍后再试')
    },
  },
}
</script>

// <style lang="less" scope>
// .kefu_box {
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   top: 150px;
//   left: 0;
//   box-sizing: border-box;
//   //   .kefu_iframe {
//   //     position: absolute;
//   //     width: 100%;
//   //     height: 85vh;
//   #kefIframe {
//     width: 100%;
//     height: 80%;
//     // }
//   }
// }
//
</style>
<style lang="less" scope>
.user_content .content-box {
  height: calc(100vh - 140px);
}
.kefu_box {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  #kefIframe {
    width: 100%;
    height: 100%;
  }
}
</style>